// Datas das fases de um projeto a partir do modelo (TEMPLATES).
// Regra: a fase de Execução dura SEMPRE o contrato (início → fim do contrato).
// As fases antes dela (planeamento, alinhamentos) ficam imediatamente antes do início do contrato,
// e as depois dela (acompanhamento e fecho) começam no fim do contrato.
// Sem as duas datas do contrato, as fases seguem-se umas às outras a partir do início (como antes).
const iso = (d) => d.toISOString().slice(0, 10);
const somaDias = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
// fase que corresponde ao período do contrato: «Execução», «Execução faseada»,
// «Implementação das Sessões» (ginástica laboral) e «Gestão Contínua» (WOW)
export const ehFaseExecucao = (nome) => /^(execu|implementa|gest[aã]o cont)/i.test(String(nome || '').trim());
const ehFollowupNome = (nome) => /^follow-?up/i.test(String(nome || '').trim());

// Projeto já existente: a fase de Execução passa a ser o contrato, e as fases seguintes
// (acompanhamento, fecho, avaliação) passam a começar no fim do contrato, com a mesma duração.
export async function sincronizarFasesContrato(supabase, projectId, contractStart, contractEnd) {
  if (!projectId || !contractStart || !contractEnd || contractEnd < contractStart) return;
  const { data: fases } = await supabase.from('project_phases').select('id,name,order_num,start_date,end_date').eq('project_id', projectId).order('order_num');
  const lista = fases || [];
  const iExec = lista.findIndex(f => ehFaseExecucao(f.name));
  if (iExec < 0) return;
  const ups = [];
  const ex = lista[iExec];
  if (ex.start_date !== contractStart || ex.end_date !== contractEnd)
    ups.push(supabase.from('project_phases').update({ start_date: contractStart, end_date: contractEnd }).eq('id', ex.id));
  let ini = new Date(contractEnd);
  for (const f of lista.slice(iExec + 1)) {
    if (ehFollowupNome(f.name)) continue;
    const dur = (f.start_date && f.end_date) ? Math.max(0, Math.round((new Date(f.end_date) - new Date(f.start_date)) / 864e5)) : 14;
    const fim = somaDias(ini, dur);
    if (f.start_date !== iso(ini) || f.end_date !== iso(fim))
      ups.push(supabase.from('project_phases').update({ start_date: iso(ini), end_date: iso(fim) }).eq('id', f.id));
    ini = fim;
  }
  await Promise.all(ups);
}

export function datasFases(tmpl, contractStart, contractEnd) {
  const iExec = tmpl.findIndex(t => ehFaseExecucao(t.nome));
  if (contractStart && contractEnd && iExec >= 0 && contractEnd >= contractStart) {
    const out = new Array(tmpl.length);
    out[iExec] = { start: contractStart, end: contractEnd };
    let fim = new Date(contractStart);
    for (let i = iExec - 1; i >= 0; i--) {
      const ini = somaDias(fim, -(tmpl[i].dias || 0));
      out[i] = { start: iso(ini), end: iso(fim) }; fim = ini;
    }
    let ini = new Date(contractEnd);
    for (let i = iExec + 1; i < tmpl.length; i++) {
      const f = somaDias(ini, tmpl[i].dias || 0);
      out[i] = { start: iso(ini), end: iso(f) }; ini = f;
    }
    return out;
  }
  let cur = contractStart ? new Date(contractStart) : new Date();
  return tmpl.map(t => { const s = new Date(cur); const e = somaDias(cur, t.dias || 0); cur = e; return { start: iso(s), end: iso(e) }; });
}
